import React from 'react'
import { SSOApi } from '../../apis/SSOApi';
import { useRadacadAuth } from '../../Core/useRadacadAuth';
import { SSOEnum } from '../../Core/SSOType';

import { ReactComponent as GoogleIcon } from '../../assets/google_icon.svg';

export function GoogleSSORemoveButton(props: {
    onStart?: () => void,
    onSuccess?: () => void,
    onFailure?: (errMsg: string) => void
}) {
    const { onStart, onSuccess, onFailure } = props;
    const { googleLogin, authState: { accessToken } } = useRadacadAuth();

    const handleOnClick = async (jwtToken: string) => {
        onStart && onStart()
     
        let booleanResponse = await SSOApi.removeSSO(SSOEnum.Google, jwtToken);
        if (booleanResponse) {
            const { success, errorMessage } = booleanResponse;
            if (success) {
                onSuccess && onSuccess()
            } else {
                onFailure && onFailure(errorMessage)
            }
        } else {
            onFailure && onFailure("Remove Google login failed");
        }
    }
    return googleLogin && accessToken ? <GoogleIcon
        style={{ cursor: 'pointer', height: "30px", width: "30px" }}
        onClick={() => handleOnClick(accessToken)} /> : <></>
}